import { render, staticRenderFns } from "./goods-comment.vue?vue&type=template&id=272de530&scoped=true&"
import script from "./goods-comment.vue?vue&type=script&lang=js&"
export * from "./goods-comment.vue?vue&type=script&lang=js&"
import style0 from "./goods-comment.vue?vue&type=style&index=0&id=272de530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272de530",
  null
  
)

export default component.exports